

<template>
    <div class="row bottom5 fs-xs">
        <div class="col-sm-9">
            Оплата: {{request?.payment?.title}}
        </div>
        <div class="col-sm-3">
            <span class="text" style="margin-left: 5px; font-size: 0.75rem;" v-if="!pay_ok">
                Змінено
            </span>
            <span class="text" style="margin-left: 5px; font-size: 0.75rem;" v-else>
                З умовами оплати згоден
            </span>
        </div>
    </div>
    
    <div class="row bottom5 fs-xs">
        <div class="col-sm-9">
            Постачання: {{request?.delivery?.title}}
        </div>
        <div class="col-sm-3">
            
            <span class="text" style="margin-left: 5px; font-size: 0.75rem;" v-if="!delivery_ok">
                Змінено
            </span>
            <span class="text" style="margin-left: 5px; font-size: 0.75rem;" v-else>
                З умовами постачання згоден
            </span>
            
        </div>
    </div>
    
    <div class="row bottom5 fs-xs">
        <div class="col-sm-9">
            Дата постачання: {{request.date_delivery}}
        </div>
        <div class="col-sm-3">
            <span class="text" style="margin-left: 5px; font-size: 0.75rem;" v-if="!date_delivery_ok">
                Змінено
            </span>
            <span class="text" style="margin-left: 5px; font-size: 0.75rem;" v-if="date_delivery_ok">
                З датою поcтачання згоден
            </span>
            
        </div>
    
    </div>
</template>

<script>
export default {
    name: "application_payment",
    props : {
        tender : {
            type : Object,
            required : true
        }
    },
    
    computed : {
        request() {
            return this.tender.request;
        },
        
        date_delivery_ok() {
            return this.request.date_delivery_ok;
        },
        
        pay_ok() {
            return this.request.payment_ok;
        },
        
        delivery_ok() {
            return this.request.delivery_ok;
        }
        
        
    }
}
</script>

<style scoped>

</style>